import { formatNumber } from "@angular/common";
import {
  Inject,
  LOCALE_ID,
  Optional,
  Pipe,
  PipeTransform,
} from "@angular/core";
import { MathHelper } from "../helpers/math-helper";
import { TCM_FORM_CONFIG, TCMFormConfig } from "../tcm-form-config";

@Pipe({
    name: "wafNumber",
    standalone: false
})
export class NumberStringPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    @Optional() @Inject(TCM_FORM_CONFIG) protected config: TCMFormConfig
  ) {}

  transform(value: number, digitInfo?: string): string {
    if (value != undefined) {
      value = MathHelper.roundToTwoDecimalPlaces(value);

      return formatNumber(
        value,
        this.locale,
        digitInfo || this.config.digitInfo
      );
    }

    return "";
  }
}
